import Header from '../../../Shared-Component/Header/Header';
import counc1 from "../../../assets/CampuLifeImages/counc1.jpg"
import Footer from "../../../Shared-Component/Footer/Footer"
import CampusTitle from '../../CampusSharedComponent/CampusTitles/CampusTitle/CampusTitle';
import CampusTableComponent from '../../CampusSharedComponent/CampusTableComponent/CampusTableComponent';
import CampusGrid from "../../CampusSharedComponent/CampusSections/CampusGridSection/CampusGrid"


const StudentCouncil = () => {

   const tableData = [
  {title:"Student Council Members"},
  {headings:[{heading1:"S.No.",heading2:"Name",heading3:"Designation & Department",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Dr. R. Marimuthu', designDept:"Principal ",pos:"President" },
    { id: 2, name: 'Dr. Ciby S. Kumar', designDept:"Asst. Prof. & Head, Department of Visual Communication", pos:"Convener"},
  ]},
 
];

const studentTableData = [
  {title:"The Students Election for the year 2024-25 was conducted on 08.01.2025. The following students have been elected to the Students’ Association."},
  {headings:[{heading1:"S.No.",heading2:"Name",heading3:"Year & Department", heading4:"Position"}]},
  {
    data: [{ id: 1, name: 'Adhitya N', designDept:"III B.Com. (Batch-I)" ,pos:"President"},
  { id: 2, name: 'Anandhu H', designDept:"III B.Sc. Visual Communication",pos:"Secretary" },
  { id: 3, name: 'Kavya Krishna U', designDept:"III Bachelor of Computer Applications (BCA)",pos:"Vice President" },
  { id: 4, name: 'Abirami R B', designDept:"III B.Sc. Microbiology",pos:"Joint Secretary" },
  { id: 5, name: 'Ashmi S', designDept:"II Bachelor of Computer Applications (BCA)",pos:"Secretary – Tamil" },
  { id: 6, name: 'Afritha Noora Nawaz', designDept:"II B.Sc. Visual Communication",pos:"Secretary – Malayalam" },
  { id: 7, name: 'Abi R S', designDept:"III B.Sc. Information Technolog ",pos:"Secretary – Sports" },
  { id: 8, name: 'Vaishnavi M', designDept:"III Bachelor of Computer Applications (BCA)",pos:"Joint Secretary - Sports" },
  { id: 9, name: 'Mathan Kumares R', designDept:"II M.Sc. Biotechnology",pos:"Secretary – PG Association" },
  { id: 10, name: 'Irish Sugan Breeze E R', designDept:"III Bachelor of Business Administaration (BBA)",pos:"Secretary – Fine Arts" },
  { id: 11, name: 'Avinosha Rai J U', designDept:"III B.Sc. Biotechnology",pos:"Executive Member" },
  { id: 12, name: 'Rojeebert R ', designDept:"III B.Sc. Computer Science",pos:"Executive Member" },
  { id: 13, name: 'Revathy R C', designDept:"III B.A. English",pos:"Executive Member" },
  { id: 14, name: 'Elavin Vasanth A', designDept:"III B.Com. (Batch-II)",pos:"Executive Member" },
  { id: 15, name: 'Malavika Vinod D', designDept:"II M.A. English",pos:"Executive Member" },
  { id: 16, name: 'Abisha N S', designDept:"III B.Sc. Information Technology",pos:"Executive Member" },
  { id: 17, name: 'Mohamed Niyas', designDept:"II M.Com.",pos:"Executive Member" },
  

]},
{padding:true}
];


  const studentCouncilContent = {
    pagename:"Student Council",
    name:"student",
    contentImg:counc1,
    viewmore:true,
    viewless:true,
    hover:true,
    paratitle:"Objectives :",
    paratitlecontents:[
      {content:"To provide a platform for students to express their views and concerns."},
      {content:"To promote student engagement and participation in activities."},
      {content:"To foster a sense of community and inclusivity on campus."},
      {content:"To provide opportunities for personal growth and development."},
      {content:"To support student well-being and mental health."}],
    paramission:"Our Mission :",
    paramissioncontent:"Our mission is to empower students to take an active role in shaping their college experience. We strive to foster a sense of community, promote student engagement, and provide opportunities for personal growth and development and provide a platform for students to voice their opinions, share their ideas, and work together to create a positive and inclusive campus environment."
  }
  return (
   <>
   <div>
      <Header />
      <div className='campusmaincontainer'>
      <div className='campus-container'>
        <CampusTitle title="Student Council" />
        <CampusGrid content={studentCouncilContent} />
        <CampusTableComponent tableData ={tableData} />
        <CampusTableComponent tableData ={studentTableData} />
        </div>
        <Footer />
        </div>
        </div>
   </>
  )
}

export default StudentCouncil